import Vue from 'vue';
import Vuex from 'vuex';
import { dialog } from './dialog/index';
import { ava } from './ava/index'
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        allowSpeech: false,
        isReady: false,
        playGroup: 'welcome',
        user: undefined,
        selectedDialogGroup: {},
        currentAudio: '',
        avaToken: '',
        watermark: 0,
        conversationId: '',
        activityId: '',
        audioSrc: '',
        idleGroup: 'idle-first',
        askAvaQuestion: ''
    },
    modules: {
        dialog,
        ava
    },
    mutations,
    actions,
    getters
});
